import { ReactNode } from 'react';

import { JobPositionIdContext, JobPositionIdContextType } from '../contexts/job-position-id.context';

const JobPositionIdContextProvider: React.FC<{ value: JobPositionIdContextType; children: ReactNode }> = ({ children, value }) => (
  <JobPositionIdContext.Provider value={value}>{children}</JobPositionIdContext.Provider>
);

export default JobPositionIdContextProvider;
